const APP = () => import('@/app.vue');
const Home = () => import('@/pages/base/home.vue');
const PageNo = () => import('@/pages/base/404.vue');
const PageTest = () => import('@/pages/base/test.vue');

const arr = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      auth: false,
    },
  },
  {
    path: '/index.html',
    redirect: '/home',
  },
  {
    path: '/',
    name: 'login',
    component: APP,
    meta: {
      auth: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: PageNo,
    meta: {
      auth: false,
    },
  },
  {
    path: '/test',
    name: 'test',
    component: PageTest,
    meta: {
      auth: false,
      noAuth: true,
    },
  },
];

export default arr;
